import React from "react";
import strings from "translate/language";
import "./PasswordResetEmailPreview.css";

/**
 * Preview of mail type 17 — forced logout notice (password unchanged).
 */
const ForceLogoutEmailPreview = ({ recipientName = "" }) => {
  const name =
    String(recipientName || "").trim() ||
    strings.forceLogoutEmailPreviewSampleName;
  const greeting = strings.forceLogoutEmailPreviewGreeting.replace(
    "{name}",
    name
  );

  return (
    <div
      className="justo-mail-preview"
      role="region"
      aria-label={strings.forceLogoutEmailPreviewLabel}
    >
      <p className="justo-mail-preview__label">
        {strings.forceLogoutEmailPreviewLabel}
      </p>
      <div className="justo-mail-preview__card">
        <div className="justo-mail-preview__meta">
          <span className="justo-mail-preview__meta-key">
            {strings.forceLogoutEmailPreviewSubject}
          </span>
          <span className="justo-mail-preview__meta-value">
            {strings.forceLogoutEmailPreviewSubjectValue}
          </span>
        </div>
        <div className="justo-mail-preview__body">
          <p className="justo-mail-preview__greeting">
            <strong>{greeting}</strong>
          </p>
          <p>{strings.forceLogoutEmailPreviewBody1}</p>
          <p>{strings.forceLogoutEmailPreviewBody2}</p>
          <p>{strings.forceLogoutEmailPreviewBody3}</p>
          <p className="justo-mail-preview__signoff">
            {strings.forceLogoutEmailPreviewSignoff}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForceLogoutEmailPreview;
